// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1w8Kc","sendOtp":"AuthorizeToLogin_sendOtp__3eQ-Y"};